import angular from 'angular';
import HeaderController from './model/header';

export default angular
	.module('app')
	.controller('HeaderController', HeaderController);
